import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import ProductTypeComponent from '../components/product-type.component';
import { productTypes } from '../../../../../redux/product-types/action';
import { selectProductTypesQueryItems } from '../../../../../redux/product-types/selector';


const ManagementProductType = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const productTypeQuery = useSelector(selectProductTypesQueryItems)
    const [
        selectedProductTypes,
        setSelectedProductTypes
    ] = useState<any>([])


    const fetchProductTypeQueryById = () => {
        dispatch(productTypes.query({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/query`, entity: 'productTypes', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedProductTypes({ ...selectedProductTypes, [field]: event })
    }



    useEffect(
        () => {
            if (parmas?.id > 0) {
                fetchProductTypeQueryById()
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedProductTypes(productTypeQuery?.result?.items)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            dispatch(productTypes.update({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types`, entity: 'productTypes', jsonData: {

                    Records: [
                        selectedProductTypes

                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            dispatch(productTypes.create({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types`, entity: 'productTypes', jsonData: {

                    Records: [
                        selectedProductTypes
                    ]

                }
            })).then(() => {
                back()
            })
        }

    }

    const back = () => {
        navigate('/management/taxonomy/product-types')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <ProductTypeComponent
                    selectedProductTypes={selectedProductTypes}
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                />
            }

        </>
    )

}

export default ManagementProductType;